import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	urlCaption: {
		id: 'navigation-shortcuts.common.messages.link-messages.url-caption',
		defaultMessage: 'Web address',
		description: '',
	},
	urlPlaceholder: {
		id: 'navigation-shortcuts.common.messages.link-messages.url-placeholder',
		defaultMessage: 'e.g. http://www.atlassian.com',
		description: '',
	},
	nameCaption: {
		id: 'navigation-shortcuts.common.messages.link-messages.name-caption',
		defaultMessage: 'Name',
		description: '',
	},
	namePlaceholder: {
		id: 'navigation-shortcuts.common.messages.link-messages.name-placeholder',
		defaultMessage: 'e.g. Atlassian website',
		description: '',
	},
	invalidUrlError: {
		id: 'navigation-shortcuts.common.messages.link-messages.invalid-url-error',
		defaultMessage: 'Please enter a valid URL',
		description: '',
	},
	proTipLabel: {
		id: 'navigation-shortcuts.common.messages.link-messages.pro-tip-label',
		defaultMessage: '😎Pro tip:',
		description: 'Label of a hint that appears in "Add shortcut" modal, under the name field',
	},
	proTipMessage: {
		id: 'navigation-shortcuts.common.messages.link-messages.pro-tip-message',
		defaultMessage: 'Start your shortcut’s name with an emoji to customize its icon.',
		description: 'Message of a hint that appears in "Add shortcut" modal, under the name field',
	},
});
